import { useEffect } from 'react';

/**
 * Hook that alerts clicks outside of the passed ref
 * @param {object} ref
 * @param {function} callback
 * @return {undefined}
 */
export const useClickOutside = (ref, callback) => {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    // Bind the event listener
    window.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      window.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
};
